import React from 'react';
import fr from 'facet-rest';
import { FDConfirmationDialog, FDSecondaryActionButton } from '@facet-wealth/design';
import { useSmartAllocationCustomizationContext } from '../../../Context';
import useResetButton from './useResetButton';

const ResetButton = () => {
  const { smartAllocCustResource } = useSmartAllocationCustomizationContext();

  const {
    onConfirm,
    onCancel,
    onClick,
    showConfirm,
    isReseting,
  } = useResetButton();

  return (
    <>
      <FDSecondaryActionButton
        onClick={onClick}
        size={'md'}
        label={smartAllocCustResource.relationship(fr.relationships.reset.name).meta('prompt')}
        icon={smartAllocCustResource.relationship(fr.relationships.reset.name).meta('icon')}
      />
      <FDConfirmationDialog
        title={'Are you sure?'}
        message={'This will reset all manual changes you have made to priorities below.'}
        confirmLabel={'Reset'}
        onClose={onCancel}
        onConfirm={onConfirm}
        loading={isReseting}
        open={showConfirm}
      />
    </>
  );
};

export default ResetButton;
